import React from "react";
import TransactionLog from "./TransactionLog";
export default function PurchaseLogs() { return <TransactionLog kind="purchase" />; }
